import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useProjectStore } from '../project/project-store';
import { RequireProject } from '../project/RequireProject';
import { DashboardPage } from '../routes/DashboardPage';
import { ComingSoonPage } from '../routes/ComingSoonPage';
import { TractsListPage } from '../routes/tracts/TractsListPage';
import { TractDetailPage } from '../routes/tracts/TractDetailPage';
import { TitleRunsListPage } from '../routes/title-runs/TitleRunsListPage';
import { RunsheetEditor } from '../routes/runsheet/RunsheetEditor';
import { DocumentsPage } from '../routes/documents/DocumentsPage';
import { DocumentsActivityPage } from '../routes/documents/DocumentsActivityPage';
import { IngestPage } from '../routes/documents/IngestPage';
import { PartiesListPage } from '../routes/parties/PartiesListPage';
import { PartyDetailPage } from '../routes/parties/PartyDetailPage';
import { ProspectsListPage } from '../routes/prospects/ProspectsListPage';
import { ContractsListPage } from '../routes/contracts/ContractsListPage';
import { ContractDetailPage } from '../routes/contracts/ContractDetailPage';

/**
 * Running Title's feature routes, namespaced under `/a/running-title/*`.
 * Paths here are relative to that prefix — this is the same route tree
 * App.tsx used to mount directly under `/*`, moved verbatim.
 */
export function RunningTitleShell() {
  // A deep-link, bookmark, or back/forward navigation into /a/running-title/*
  // can land here without ever going through HomePage/TopBar's setApp click
  // handlers, leaving the project-store's appKey null or stale (wrong app's
  // project switcher/nav). setApp() already no-ops when unchanged, so this
  // only fires (and clears any stale cross-app project selection) when the
  // store doesn't already agree with the route.
  useEffect(() => {
    if (useProjectStore.getState().appKey !== 'running_title') {
      useProjectStore.getState().setApp('running_title');
    }
  }, []);

  return (
    <Routes>
      <Route index element={<DashboardPage />} />
      <Route
        path="tracts"
        element={
          <RequireProject>
            <TractsListPage />
          </RequireProject>
        }
      />
      <Route
        path="tracts/:id"
        element={
          <RequireProject>
            <TractDetailPage />
          </RequireProject>
        }
      />
      <Route
        path="title-runs"
        element={
          <RequireProject>
            <TitleRunsListPage />
          </RequireProject>
        }
      />
      <Route
        path="title-runs/:id"
        element={
          <RequireProject>
            <RunsheetEditor />
          </RequireProject>
        }
      />

      <Route
        path="parties"
        element={
          <RequireProject>
            <PartiesListPage />
          </RequireProject>
        }
      />
      <Route
        path="parties/:id"
        element={
          <RequireProject>
            <PartyDetailPage />
          </RequireProject>
        }
      />
      <Route
        path="prospects"
        element={
          <RequireProject>
            <ProspectsListPage />
          </RequireProject>
        }
      />
      <Route
        path="contracts"
        element={
          <RequireProject>
            <ContractsListPage />
          </RequireProject>
        }
      />
      <Route
        path="contracts/:id"
        element={
          <RequireProject>
            <ContractDetailPage />
          </RequireProject>
        }
      />
      <Route
        path="documents"
        element={
          <RequireProject>
            <DocumentsPage />
          </RequireProject>
        }
      />
      <Route
        path="documents/activity"
        element={
          <RequireProject>
            <DocumentsActivityPage />
          </RequireProject>
        }
      />
      <Route
        path="documents/ingest"
        element={
          <RequireProject>
            <IngestPage />
          </RequireProject>
        }
      />
      <Route path="requirements" element={<ComingSoonPage name="Requirements" />} />

      <Route path="*" element={<Navigate to="/a/running-title" replace />} />
    </Routes>
  );
}
